import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import {
  BuildInvoiceScreen,
  PickPatientScreen,
} from "../../../screens/invoices/new-invoice-screen";
import { invoiceDraftQuery, worklistQuery } from "../../../screens/invoices/queries";
import { LoadErrorScreen, NotFoundScreen } from "../../../screens/invoices/shared";

export const Route = createFileRoute("/_authed/invoices/new")({
  validateSearch: z.object({ patient: z.string().optional().catch(undefined) }),
  beforeLoad: ({ context }) => {
    if (!can(context.session.role, "invoice:manage")) throw redirect({ to: "/" });
  },
  loaderDeps: ({ search }) => ({ patient: search.patient }),
  loader: ({ context, deps }) =>
    deps.patient
      ? context.queryClient.ensureQueryData(invoiceDraftQuery(deps.patient))
      : context.queryClient.ensureQueryData(worklistQuery),
  errorComponent: () => <LoadErrorScreen title={t.invoices.newInvoice} />,
  notFoundComponent: NotFoundScreen,
  component: () => {
    const { patient } = Route.useSearch();
    return patient ? <BuildInvoiceScreen patientId={patient} /> : <PickPatientScreen />;
  },
});
